import React, {useContext, useState} from 'react';
import {FormattedMessage} from "react-intl";

import CancelButtonStyled from "components/button/CancelButtonStyled";
import {ListContext} from "components/List/context/ListContext";

import {fetchSyliusCandidates} from "api/shippingMethod/syliusCandidates";
import {SyliusCandidatesContext} from "views/shippingMethods/context/SyliusCandidatesContext";

function FetchFromSyliusButton(props) {
    const [fetching, setFetching] = useState(false);
    const {setCandidates, setFetchReport} = useContext(SyliusCandidatesContext);
    const {showErrorNotification} = useContext(ListContext);

    function fetchFromSylius() {
        setFetching(true);

        fetchSyliusCandidates()
            .then(report => {
                setCandidates(report.candidates ?? []);
                setFetchReport(report);
            })
            .catch(() => showErrorNotification())
            .finally(() => setFetching(false));
    }

    return (
        <CancelButtonStyled disabled={fetching} onClick={fetchFromSylius}>
            <FormattedMessage id={fetching ? 'shippingMethods.sylius.fetching' : 'shippingMethods.sylius.fetch'} />
        </CancelButtonStyled>
    );
}

export default FetchFromSyliusButton;
